import '.fy{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fz{padding-left:1.5rem;}.ssr-plugin'
import '.g0{margin:1rem 0;}.ssr-plugin'
import '.g1{color:var(--gray-700);}.ssr-plugin'
import '.g2{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fy fz g0 g1 g2"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
